// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cde78544","86":"cbe75089","101":"6b4a905d","138":"0e427f0e","147":"fbcf246e","151":"69297ae4","240":"3fe5589b","363":"e2162c70","373":"5bb6422a","464":"8ba0618e","503":"7658428d","703":"ae3f0205","832":"9d82985f","886":"442f9c41","918":"e67596f3"}[chunkId] + ".chunk.js";
};